import { render, staticRenderFns } from "./courseCertificate.vue?vue&type=template&id=58205ac3&"
import script from "./courseCertificate.vue?vue&type=script&lang=js&"
export * from "./courseCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports